import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import PlaybackButton from './playbackButton';

import { PlayerProvider, Player } from '../../../hooks/player/Player';

interface AudioPlayerProps {
  audioURL: string;
  noMargin?: boolean;
}

const AudioPlayer = ({ audioURL, noMargin }: AudioPlayerProps) => (
  <PlayerProvider src={audioURL}>
    <Player>
      {(context) => (
        <Stack
          direction='row'
          spacing={1}
          width={noMargin ? '100%' : '95%'}
          alignItems='center'
          marginLeft={noMargin ? 'unset' : 'auto'}
        >
          <PlaybackButton
            onClick={context.togglePlay}
            isPaused={!context.isPlaying}
          />
          <Typography>{context.timestamp.current}</Typography>
          <Box flexGrow={1}>
            <LinearProgress
              variant='determinate'
              color='inherit'
              value={context.progress}
            />
          </Box>
        </Stack>
      )}
    </Player>
  </PlayerProvider>
);

export default AudioPlayer;
